import { defineMessages } from 'react-intl';
var messages = defineMessages({
  deleteAttachmentTitle: {
    id: "Assignment.Attachment.deleteAttachmentTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Delete attachment"
    }]
  },
  type: {
    id: "Assignment.Attachment.type",
    defaultMessage: [{
      "type": 0,
      "value": "Type:"
    }]
  },
  size: {
    id: "Assignment.Attachment.size",
    defaultMessage: [{
      "type": 0,
      "value": "Size:"
    }]
  },
  uploaded: {
    id: "Assignment.Attachment.uploaded",
    defaultMessage: [{
      "type": 0,
      "value": "Uploaded:"
    }]
  },
  socketServerValidating: {
    id: "Assignment.Attachment.socketServerValidating",
    defaultMessage: [{
      "type": 0,
      "value": "The file is under validation, wait a while."
    }]
  }
});
export default messages;